export const colors = {
  primary: "#670934",
  secondary: "#f47920",
  accent: "#00C2FF",
  text: "#0d5a96",
  background: "#dee2e1",
};

//main #640b33 #650a33
//white #fefffe
//text #0d5a96
